/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SquadImportResponse = {
    type: 'array',
    contains: {
        type: 'any-of',
        contains: [{
            type: 'SquadImport_Output',
        }, {
            type: 'string',
        }],
    },
} as const;
